var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsObject, IsOptional, IsString, IsUUID } from 'class-validator';
import { ExerciseProgramLiteDto } from '../../exercise-programs/dtos/exercise-program.lite.dto.js';
export class ExerciseTemplateFolderFullSizeDto {
    id;
    createdAt;
    updatedAt;
    name;
    exercisePrograms;
    officeId;
    office;
}
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], ExerciseTemplateFolderFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Date)
], ExerciseTemplateFolderFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    IsOptional(),
    __metadata("design:type", Date)
], ExerciseTemplateFolderFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], ExerciseTemplateFolderFullSizeDto.prototype, "name", void 0);
__decorate([
    IsArray(),
    Type(() => ExerciseProgramLiteDto),
    Expose(),
    IsOptional(),
    __metadata("design:type", Array)
], ExerciseTemplateFolderFullSizeDto.prototype, "exercisePrograms", void 0);
__decorate([
    IsUUID(),
    Exclude(),
    IsOptional(),
    __metadata("design:type", Object)
], ExerciseTemplateFolderFullSizeDto.prototype, "officeId", void 0);
__decorate([
    IsObject(),
    Exclude(),
    IsOptional(),
    __metadata("design:type", Function)
], ExerciseTemplateFolderFullSizeDto.prototype, "office", void 0);
//# sourceMappingURL=exercise-template-folder.full-size.dto.js.map